import {RootState} from '../rootReducer';

export const scenarioExecutionSelector = (state: RootState) => state.scenarioExecution;
